<span class="twitter-share-button icon" (click)="share()">
    <app-icon [type]="'Twitter'"></app-icon>
</span>
